import type { AppConfig } from '@/config/AppConfig';

const onRedirectCallback = (redirectState?: { returnTo?: string }) => {
  if (redirectState?.returnTo) {
    const nextUrl = new URL(redirectState.returnTo, window.location.origin);
    // Only redirect if it's the same origin
    if (nextUrl.origin === window.location.origin) {
      window.location.replace(nextUrl.toString());
    }
  }
};

// Function to create Auth0 config from AppConfig
export const createAuth0Config = (appConfig: AppConfig) => {
  return {
    domain: appConfig.auth0Domain,
    clientId: appConfig.auth0ClientId,
    authorizationParams: {
      redirect_uri: `${window.location.origin}/login`,
      audience: appConfig.auth0Audience,
    },
    onRedirectCallback,
    cacheLocation: 'localstorage' as const,
    useRefreshTokens: true,
    sessionCheckExpiryDays: 7,
  };
};

// Validate required Auth0 configuration
export const validateAuth0Config = (config: AppConfig): boolean => {
  const hasRequiredFields =
    config.auth0Domain && config.auth0ClientId && config.auth0Audience;

  if (!hasRequiredFields) {
    console.error('Missing required Auth0 configuration in AppConfig:', {
      hasDomain: !!config.auth0Domain,
      hasClientId: !!config.auth0ClientId,
      hasAudience: !!config.auth0Audience,
    });
    return false;
  }

  return true;
};
